// extracted by mini-css-extract-plugin
export default {"card":"Admin_card__y0K9s","cardPartner":"Admin_cardPartner__BoUo4"};